export const NAV_COLLAPSE_ID = 'navbar-collapse'
export const NAV_MENU_TRIGGER_ID = 'navbar-menu-trigger'

export const EXPERTISES_SUBMENU_ID = 'expertises-submenu'
export const EXPERTISES_TRIGGER_ID = 'expertises-menu-trigger'

export const EXPERTISE_NAV_PATH_ID = 10
